export class ResourcesService {
  static translateInput(
    textBg: string,
    textEn: string,
    textThird: string,
    language?: string
  ): string {
    if (
      language &&
      (language === "EN" ||
        language === "en" ||
        language.toLocaleLowerCase() === "en")
    ) {
      return textEn;
    }

    if (
      language &&
      (language === "RO" ||
        language === "ro" ||
        language.toLocaleLowerCase() === "ro")
    ) {
      return textThird;
    }

    return textBg;
  }
  static translate(text: string, language?: string): string {
    if (
      language &&
      (language === "EN" ||
        language === "en" ||
        language.toLocaleLowerCase() === "en")
    ) {
      return text;
    }
    const resources: {
      key: string;
      translations: { bg: string; ro?: string };
    }[] = require("../locales/resources.json");

    const item = resources.find((r) => r.key === text);

    if (!item) {
      return text;
    }

    if (
      language &&
      (language === "RO" ||
        language === "ro" ||
        language.toLocaleLowerCase() === "ro")
    ) {
      return item.translations.ro || item.translations.bg || text;
    }

    return item.translations.bg || text;
  }
}
